import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import { useRouter } from 'next/router';
import { AnimatedGrid } from '../../us/StatusA/Components/AnimatedSection';
import CommonTitle from '../../us/StatusA/Components/CommonTitle';
import styles from './index.module.scss';

interface PhoneSectionConfig {
    title?: string;
    desc?: string;
    list: {
        item: React.ReactNode;
        pc: string;
    };
}
interface PhoneSectionProps {
    config?: Partial<PhoneSectionConfig>;
}
const PhoneSection: React.FC<PhoneSectionProps> = (props) => {
    const { t } = useLang('PhoneSection');
    const { locale = 'us' } = useRouter();

    const imgArray = {
        us: [
            'https://websiteoss.ecoflow.com/figma-uploads/1757491649448-bu45im-compressed-Output.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1757498474682-1z4t2b-compressed-Solar%20Generation.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1757491689148-0b114n-compressed-Earning.png',
        ],
        eu: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761546920604-e9u29q-compressed-Output.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761546934932-nk53o7-compressed-Solar%20Generation.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761546949654-xryij8-compressed-Earning.png',
        ],
        de: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761115710840-am069r-compressed-Output.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761115727984-102y49-compressed-Solar%20Generation.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761115744867-s5kt5i-compressed-Earning.png',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761115763261-e2qfh0-compressed-Output.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761115780165-rm43x9-compressed-Solar%20Generation.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761115795630-unhhe5-compressed-Earning.png',
        ],
        it: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761115812821-6y46j0-compressed-Output.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761115830825-m3ywuc-compressed-Solar%20Generation.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761115847689-ondrlu-compressed-Earning.png',
        ],
        es: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761115878989-hpqncd-compressed-Output.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761115914481-zz80sd-compressed-Solar%20Generation.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761115929509-iscsuh-compressed-Earning.png',
        ],
        //delta-3-max-plus-portable-power-station uk
        uk: [
            'https://websiteoss.ecoflow.com/figma-uploads/1757491649448-bu45im-compressed-Output.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1757498474682-1z4t2b-compressed-Solar%20Generation.png',
            'https://websiteoss.ecoflow.com/upload/image/1765356603502/Earning%20(1).png',
        ],
    };

    // 获取当前语言的图片，如果不存在则使用英文版
    const currentImages = imgArray[locale] || imgArray.us;

    const defaultConfig = {
        title: t('title'),
        desc: t('desc'),
        list: [
            { item: t('item1'), pc: currentImages[0] },
            { item: t('item2'), pc: currentImages[1] },
            {
                item: t.rich('item3', {
                    sup: (text: string) => <sup>{text}</sup>,
                }),
                pc: currentImages[2],
            },
        ],
    };
    const config = { ...defaultConfig, ...props.config };

    const list = (props.config?.list || defaultConfig.list).map((item: any, index: number) => ({
        ...defaultConfig.list[index],
        ...item,
    }));

    return (
        <div className={`page-phoneSection ${styles.PhoneSection} GtmModuleData-section`} id="phoneSection" data-section-id="d3m-phone-section">
            {/* <AnimatedSection variant="fadeInUp" options={{ delay: 400 }}>
                <EcoSectionCommon className={`section-content enter`} title={config.title} desc={config.desc} />
            </AnimatedSection> */}
            <CommonTitle title={config.title} desc={config.desc} />
            <AnimatedGrid variant="rotateIn" options={{ delay: 400, stagger: 0.15, threshold: 0.2 }} className="content">
                {list.map((item, index) => {
                    return (
                        <div className="item" key={index}>
                            <EcoImg pc={item.pc} isOpenLazy={true} />
                            <div className="text">{item.item}</div>
                        </div>
                    );
                })}
            </AnimatedGrid>
        </div>
    );
};

export default PhoneSection;
